// import General from './General';

export default {
  // component: General,
  component: load(() => import(/* webpackChunkName: "Feed-Report-General" */ './General')),
  permissions: ['FeedingConsoleMenu/FeedingConsoleReport/ReportGeneralReportMenu'],
  name: app.translate('routes.home.feed.General'),
  name: app.translate('آمار رزرو در سلف'),
  icon: 'clipboard-check',
  drawer: true,
};
